import { SupportedTicker } from '@/constants/token'

export interface GetTxHistoryParams {
  count: number
  offset: number
  address?: string
  coin?: SupportedTicker
  from_date?: number
  to_date?: number
  from_chain_id?: TxHistoryChainId
  to_chain_id?: TxHistoryChainId
}

export type TxHistoryChainId = -1 | 0 | 1 | 56 | 97 | 137 | 80001

/* 
  -1: unknown
  0: pending
  1: completed
*/
export enum TxStatus {
  'unknown' = -1,
  'pending' = 0,
  'confirmed' = 1,
}

export interface TxHistory {
  amount: string
  bridge_fee: string
  coin: string
  ctime: number
  from_addr: string
  from_chain_id: TxHistoryChainId
  from_status: number
  from_tx_id: string
  from_tx_ts: string
  to_addr: string
  to_chain_id: TxHistoryChainId
  to_status: number
  to_tx_id: string
  to_tx_ts: string
}
